import React from 'react';
import styled from 'styled-components';

const Logo = (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none">
		<rect
			width="23.1554"
			height="23.1554"
			rx="6"
			fill="url(#paint0_linear_1_4728)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.64312 3.02033C6.08583 3.91078 3.92106 7.52702 4.80821 11.0975C5.69502 14.667 11.8086 20.4379 13.8597 19.9896C15.9097 19.5413 18.5797 11.4436 17.6916 7.87265C16.8056 4.30295 13.2016 2.12999 9.64312 3.02033Z"
			fill="white"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11.9515 12.3131C10.3947 12.7024 8.81853 11.7525 8.43029 10.1894C8.04182 8.62716 8.99046 7.04533 10.546 6.65516C12.1038 6.26593 13.6801 7.21679 14.068 8.77818C14.4557 10.3409 13.5097 11.9239 11.9515 12.3131Z"
			fill="#F27339"
		/>
		<defs>
			<linearGradient
				id="paint0_linear_1_4728"
				x1="-0.150386"
				y1="-1.04621e-07"
				x2="23.3059"
				y2="23.1163"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FFA361" />
				<stop offset="1" stopColor="#EB5B25" />
			</linearGradient>
		</defs>
	</svg>
);

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  padding-bottom: 15px;
  margin: 24px 0;
  position: relative;
  &::after {
    content: '';
    display: block;
    width: 100%;
    max-width: 327px;
    height: 1px;
    background: #d9ebf1;
    position: absolute;
    bottom: 0px;
  }
  @media screen and (max-width: 450px) {
    &::after {
      width: 100vw;
      max-width: none;
    }
  }
`;

const FoText = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #f58a3c;
`;

const HeaderLogo = () => (
  <LogoWrapper>
    {Logo}
    <FoText>Familo</FoText>
  </LogoWrapper>
);

export default HeaderLogo;
